/**
 * Never points back at an auth page and never nests a `redirect=`: the 401 handler folds the whole current URL
 * in, which runs away as /login?redirect=%2Flogin%3Fredirect%3D…. `undefined` where there is no meaningful
 * destination, so callers omit the param rather than aim it at /login.
 * ALSO the open-redirect guard: the resolved target goes through `safeRelativePath`, so only a same-origin
 * relative path comes back — an absolute one reaches `navigate({ href })` and leaves the origin, the router
 * blocking `javascript:` and flattening `//host` but nothing else (the OAuth callback: `resolvePostLoginPath`).
 */
// From the LEAF, not `shared/post-login`: this module sits in main.tsx's entry graph and post-login.ts drags
// the applicant/company schemas in behind it.
import { safeRelativePath } from 'shared/safe-redirect'

const AUTH_PATH_SUFFIXES = ['/login', '/register']

export function resolveRedirectTarget(candidate: string | null | undefined): string | undefined {
  let target = candidate ?? ''
  // Normal flows resolve in one step; the bound only guards a pathological hand-crafted URL.
  for (let depth = 0; depth < 25; depth++) {
    if (!target) return undefined
    const queryStart = target.indexOf('?')
    const path = queryStart === -1 ? target : target.slice(0, queryStart)
    if (!AUTH_PATH_SUFFIXES.some((suffix) => path.endsWith(suffix))) return safeRelativePath(target)
    // URLSearchParams.get decodes exactly one layer of percent-encoding, peeling off one nesting level.
    const query = queryStart === -1 ? '' : target.slice(queryStart + 1)
    const inner = new URLSearchParams(query).get('redirect')
    if (!inner) return undefined
    target = inner
  }
  return undefined
}
